module.exports = "https://static.energy5.com/_next/static/images/softwareApp-e7f9752c72cd8151c401d00eb858cce9.png";